import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, ElementRef, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { HelperService } from 'src/app/core/services/helper.service';
import { Storage } from '@ionic/storage';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { VendorBackendService } from 'src/app/core/services/vendor-services/vendor-backend.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.page.html',
  styleUrls: ['./profile.page.scss'],
})
export class ProfilePage implements OnInit {

  @ViewChild('companyLogo') _companyLogo: ElementRef;
  @ViewChild('profileImage') _profileImage: ElementRef;

  breadcrumbList = [
    {
      label: 'My Profile',
      embedurl: true,
      url: '/vendor/baseapp/profile'
    }
  ];
  jobTitle = [];
  employee = [];
  countries: any = []; 
  profileObj;
  updateProfileform: UntypedFormGroup;
  submitted: boolean = false;
  hide1200: boolean = false;
  userIp;
  isEnableCompanyLogoChanges: boolean = false;
  isCompanyLogoPresentInServer: boolean = false;
  isEnableProfileImageChanges: boolean = false;
  isProfileImagePresentInServer: boolean = false;
  profileImagePath: SafeUrl = "../assets/images/profile-avatar.svg";
  companyLogoPath: SafeUrl = "../assets/images/default-company-logo.svg";
  selectedCompanyLogoFileBlob;
  selectedProfileFileBlob;
  companyLogoId;
  organizationId;
  profileImageId;
  countriesApi: any;
  profileInfo: any;
  roleId;

  constructor(
    private formBuilder: UntypedFormBuilder,
    public breakpointObserver: BreakpointObserver,
    private vendorBackendService: VendorBackendService,
    private router: Router,
    public storage: Storage,
    private sanitizer: DomSanitizer,
    public helperService: HelperService
    ) { }

  ngOnInit() {
    this.jobTitle = [
      { id: '1', name: 'CXO/General Manager' },
      { id: '2', name: 'IT Manager' },
      { id: '3', name: 'Operations Manager' },
      { id: '4', name: 'Consultant' },
      { id: '5', name: 'Developer/Software Engineer/Analyst' },
      { id: '6', name: 'Student/Personel Interest' },
      { id: '7', name: 'Others' }];
    this.employee = [
      { id: '1', name: '1 - 15 Employees' },
      { id: '2', name: '15 - 100 Employees' },
      { id: '3', name: '101 - 500 Employees' },
      { id: '4', name: '501 - 1500 Employees' },
      { id: '5', name: '1500+ Employees' }];

    this.updateProfileform = this.formBuilder.group({
      'firstName': ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9\s]+([a-zA-Z0-9 ]+)*$')]],
      'lastName': ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9\s]+([a-zA-Z0-9 ]+)*$')]],
      'email': ['', [Validators.required, Validators.email, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
      'phone': ['', [Validators.required, Validators.pattern('^[0-9+(][0-9-+(). ]*$'),
      Validators.minLength(10), Validators.maxLength(18)]],
      'jobTitle': ['', Validators.required],
      'employee': ['', Validators.required],
      'company': ['', Validators.required],
      'country': ['', Validators.required],
      'company_address': [''],
      'mfa_enabled':['', Validators.required]
    });
    this.breakpointObserver.observe(['(min-width: 1200px)']).subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.hide1200 = true;
      } else {
        this.hide1200 = false;
      }
    });
    this.getcountries();
    this.getUserIp();
    this.getProfileDetails();
  }

  get f() { return this.updateProfileform.controls; }

  async getStorage() {
    let data = {
      token: await this.storage.get("token"),
      userId: await this.storage.get("id"),
      role_id: await this.storage.get("role_id"),
      firstName: await this.storage.get("first_name"),
      lastName: await this.storage.get("last_name"),
      jobTitle: await this.storage.get("job_title"),
      profileImageId: await this.storage.get("profile_image_id")
    }
    return data;
  }

  getUserIp() {
    this.vendorBackendService.getUserIp().subscribe(
      (data) => {
        const e: any = data as any;
        this.userIp = e.ip;
      })
  }

  getcountries() {
    // this.helperService.loader();
    this.countriesApi = this.vendorBackendService.Get('getAllCountries').subscribe(
      (data) => {
        this.countries = data;
        // this.helperService.closeLoader();
      },
      (error) => {
        //console.log(error);
        // this.helperService.closeLoader();
        this.helperService.presentToast(error.error.detail, 2000);
      }
    );
  }

  getProfileDetails() {
    this.getStorage().then(async (storageVal) => {
      await this.helperService.loader();
      //console.log(storageVal);
      let payload = {
        id: storageVal.userId
      }
      this.profileInfo = this.vendorBackendService.PostAPICall('getProfileInfo', payload, storageVal.token).subscribe(
        (data) => {
          this.helperService.closeLoader();
          let profile_res = data;
          //console.log(profile_res);
          this.roleId = storageVal.role_id;
          // this.organizationId = profile_res.organization_id;
          this.profileObj = profile_res;
          
          this.updateProfileform.patchValue(
            {
              firstName: profile_res.first_name,
              lastName: profile_res.last_name,
              email: profile_res.email,
              phone: profile_res.phone_no,
              jobTitle:profile_res.job_title,
              employee: profile_res.employee,
              company: profile_res.company,
              company_address: profile_res.company_address,
              country: profile_res.country,
              mfa_enabled: profile_res.mfa_enabled
            })
          this.storage.set('profile_image_id', profile_res.profile_img_id);
          this.profileImageId = profile_res.profile_img_id;
          this.isProfileImagePresentInServer = profile_res.profile_img_id == null ? false : true;

          if (profile_res.profile_img_id != null) {
            this.getProfileImage(profile_res.profile_img_id);
          }
        },
        (error) => {
          //console.log(error);
          this.helperService.closeLoader();
          this.helperService.presentToast(error.error.detail, 2000);
        }
      );
    })
  }

  clearProfileImage() {
    this._profileImage.nativeElement.value = '';
    this.isEnableProfileImageChanges = false;
    this.profileImagePath = "../assets/images/profile-avatar.svg";
  }

  getProfileImage(id) {
    this.getStorage().then((res) => {
      let payload = {
        "img_collection_id": id
      }
      let method = 'post';
      this.vendorBackendService.fileUpload('getProfileImage', method, payload, res.token).subscribe(
        (data: any) => {
          this.helperService.closeLoader();
          this.profileImagePath = 'data:image/jpg;base64,' + data.profileImage_hash;
        },
        (error) => {
          //console.log(error);
          this.helperService.closeLoader();
          this.helperService.presentToast(error.error.detail, 3000);
        }
      );
    })
  }

  uploadProfileImage(event: any) {
    if (event.target.files && event.target.files[0]) {
      if (event.target.files[0].type && event.target.files[0].type.split('/')[0] == "image" && event.target.files[0].size <= 200000) {
        this.selectedProfileFileBlob = event.target.files[0];
        var reader = new FileReader();
        reader.onload = (event: any) => {
          this.isEnableProfileImageChanges = true;
          this.profileImagePath = this.sanitizer.bypassSecurityTrustResourceUrl(event.target.result);
        }
        reader.readAsDataURL(event.target.files[0]);
      } else {
        this._profileImage.nativeElement.value = '';
        this.helperService.presentToast("Max image upload size is 200KB only", 3000);
      }
    }
  }

  addNewProfileImage() {
    this.getStorage().then((res) => {
      const payload = new FormData();
      payload.append('profileImage', this.selectedProfileFileBlob);
      let method = 'post';
      this.vendorBackendService.fileUpload('saveProfileImage', method, payload, res.token).subscribe(
        (data) => {
          this.isEnableProfileImageChanges = false;
          this.helperService.reloadPage();
        },
        (error) => {
          //console.log(error);
          this.helperService.presentToast(error.error.detail, 3000);
        }
      );
    })
  }

  updateExistingProfileImage() {
    this.getStorage().then((res) => {
      const payload = new FormData();
      payload.append('profileImage', this.selectedProfileFileBlob);
      payload.append('img_collection_id', this.profileImageId);
      let method = 'put';
      this.vendorBackendService.fileUpload('updateProfileImage', method, payload, res.token).subscribe(
        (data) => {
          this.isEnableProfileImageChanges = false;
          this.helperService.reloadPage();
        },
        (error) => {
          //console.log(error);
          this.helperService.presentToast(error.error.detail, 3000);
        }
      );
    })
  }



  clearCompanyLogo() {
    this._companyLogo.nativeElement.value = '';
    this.isEnableCompanyLogoChanges = false;
    this.companyLogoPath = "../assets/images/default-company-logo.svg";
  }

  getCompanyLogo(id) {
    this.getStorage().then((res) => {
      let payload = {
        "img_collection_id": id
      }
      let method = 'post';
      this.vendorBackendService.fileUpload('getLogoImage', method, payload, res.token).subscribe(
        (data: any) => {
          this.companyLogoPath = 'data:image/jpg;base64,' + data.logo_hash;
        },
        (error) => {
          //console.log(error);
          // this.helperService.presentToast(error.error.detail, 3000);
        }
      );
    })
  }

  uploadCompanyLogo(event: any) {
    if (event.target.files && event.target.files[0]) {
      if (event.target.files[0].type && event.target.files[0].type.split('/')[0] == "image" && event.target.files[0].size <= 100000) {
        this.selectedCompanyLogoFileBlob = event.target.files[0];
        var reader = new FileReader();
        reader.onload = (event: any) => {
          this.isEnableCompanyLogoChanges = true;
          this.companyLogoPath = this.sanitizer.bypassSecurityTrustResourceUrl(event.target.result);
        }
        reader.readAsDataURL(event.target.files[0]);
      } else {
        this._companyLogo.nativeElement.value = '';
        this.helperService.presentToast("Max image upload size is 100KB only", 3000);
      }
    }
  }

  addNewCompanyLogo() {
    this.getStorage().then((res) => {
      const payload = new FormData();
      payload.append('logo', this.selectedCompanyLogoFileBlob);
      payload.append('organization_id', this.organizationId);
      let method = 'post';
      this.vendorBackendService.fileUpload('saveCompanyLogo', method, payload, res.token).subscribe(
        (data) => {
          this.isEnableCompanyLogoChanges = false;
        },
        (error) => {
          //console.log(error);
          this.helperService.presentToast(error.error.detail, 3000);
        }
      );
    })
  }

  updateExistingCompanyLogo() {
    this.getStorage().then((res) => {
      const payload = new FormData();
      payload.append('logo', this.selectedCompanyLogoFileBlob);
      payload.append('img_collection_id', this.companyLogoId);
      let method = 'put';
      this.vendorBackendService.fileUpload('updateCompanyLogo', method, payload, res.token).subscribe(
        (data) => {
          this.isEnableCompanyLogoChanges = false;
        },
        (error) => {
          //console.log(error);
          this.helperService.presentToast(error.error.detail, 3000);
        }
      );
    })
  }

  onSubmit() {
    this.getStorage().then(async (storageVal) => {
      await this.helperService.loader();
      //console.log(storageVal);
      if (storageVal.role_id == 2) {
        if (this.updateProfileform.invalid) {
          this.helperService.presentToast("Form incomplete", 2000);
          return;
        }
      } else {
        if (this.updateProfileform.value.firstName == '' || this.updateProfileform.value.firstName == undefined) {
          this.helperService.presentToast("Form incomplete", 2000);
          return;
        }
        if (this.updateProfileform.value.lastName == '' || this.updateProfileform.value.lastName == undefined) {
          this.helperService.presentToast("Form incomplete", 2000);
          return;
        }
      }
      let payload: any;
      payload = {
        id: this.profileObj.id,
        first_name: this.updateProfileform.value.firstName,
        last_name: this.updateProfileform.value.lastName,
        phone_no: this.updateProfileform.value.phone,
        job_title: this.updateProfileform.value.jobTitle,
        company: this.updateProfileform.value.company,
        country: this.updateProfileform.value.country,
        update_ip_address: this.userIp
      }
      this.vendorBackendService.PutAPICall('updateProfileInfo', payload, storageVal.token).subscribe(
        (data) => {
          //console.log(data)
          // if (storageVal.role_id == 2) {

          //   this.storage.set('job_title', this.updateProfileform.value.jobTitle);
          //   let obj = {};
          //   obj = {
          //     jobTitle: this.updateProfileform.value.jobTitle
          //   }
          //   this.helperService.dataFromStorage(obj);
          //   if (this.isCompanyLogoPresentInServer) {
          //     if (this.isEnableCompanyLogoChanges) {
          //       this.updateExistingCompanyLogo();
          //     }
          //   } else if (this.selectedCompanyLogoFileBlob != undefined) {
          //     this.addNewCompanyLogo();
          //   }
          // }

          if (this.isProfileImagePresentInServer) {
            if (this.isEnableProfileImageChanges) {
              this.updateExistingProfileImage();
            }
          } else if (this.selectedProfileFileBlob != undefined) {
            this.addNewProfileImage();
          }
          this.setProfileInfo().then(() => {
            this.helperService.closeLoader().then(() => {
              this.helperService.presentToast(data.msg, 2000);
              // this.helperService.loader();
            });
          })
        },
        (error) => {
          //console.log(error);
          this.helperService.handleError(error);
              this.helperService.closeLoader();
        }
      );
    })
  }

  async setProfileInfo() {
    await this.storage.set('email', this.updateProfileform.value.email);
    await this.storage.set('first_name', this.updateProfileform.value.firstName);
    await this.storage.set('last_name', this.updateProfileform.value.lastName);
  }

  ngOnDestroy() {
    this.getStorage().then((res) => {
      if (res.role_id == 2) {
        this.countriesApi.unsubscribe();
      }
    })
    this.profileInfo.unsubscribe();
    this.helperService.closeLoader();
  }

  enableMfaToggle(event){
    if(event.checked == true){
      this.router.navigate(['vendor/baseapp/multi-factor-auth'])
    }else{
      this.disableQR();
    }
  }

  disableQR(){
    this.getStorage().then((res) => {
      let payload = {
          "user_id" :res.userId
      };
      this.vendorBackendService.PostAPICall("disableQR", payload, res.token).subscribe(
          (data) => {
            this.helperService.presentToast(data.msg, 2000);
            //console.log(data);
          })
  })
  }
}
